var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
import { Service } from '~/core/service';
var CaseInfoService = /** @class */ (function (_super) {
    __extends(CaseInfoService, _super);
    function CaseInfoService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 案件颜色打标
     */
    CaseInfoService.prototype.caseInfoMarkColor = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.caseInfoMarkColor,
            data: data,
        });
    };
    /**
     * 查看材料
     */
    CaseInfoService.prototype.getFollowupFile = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.getFollowupFile,
            data: data,
        });
    };
    /**
     * 查看附件
     */
    CaseInfoService.prototype.findUpload = function (caseNumber, companyCode) {
        if (companyCode === void 0) { companyCode = ''; }
        return this.netService.send({
            server: domainService.caseInfoController.findUpload,
            data: {
                caseNumber: caseNumber,
                companyCode: companyCode,
            },
        });
    };
    /**
     * 案件查找
     */
    CaseInfoService.prototype.findCaseInfo = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.findCaseInfo,
            data: {
                'personalInfo.mobileNo': data.mobileNo,
                'personalInfo.name': data.personName,
                'principalId.id': data.principalId,
                'area.parent.id': data.parentAreaId,
                'area.id': data.areaId,
            },
            page: page,
        });
    };
    /**
     * 修改备注
     */
    CaseInfoService.prototype.modifyCaseMemo = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.modifyCaseMemo,
            data: data,
        });
    };
    /**
     * 分页查询内催待分配案件
     */
    CaseInfoService.prototype.getInnerWaitCollectCase = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.getInnerWaitCollectCase,
            data: {
                'personalInfo.name': data.name,
                'personalInfo.mobileNo': data.mobileNo,
                'personalInfo.idCard': data.idCard,
                'principalId.id': data.principalId,
                batchNumber: data.batchNumber,
                'area.parent.id': data.parentAreaId,
                'area.id': data.areaId,
                commissionRate: [data.commissionRate.min, data.commissionRate.max],
                overdueAmount: [data.overdueAmount.min, data.overdueAmount.max],
                payStatus: data.payStatus,
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                delegationDate: [
                    FilterService.dateRanageFormat(data.delegationDate).start,
                    FilterService.dateRanageFormat(data.delegationDate).end,
                ],
                closeDate: [
                    FilterService.dateRanageFormat(data.closeDate).start,
                    FilterService.dateRanageFormat(data.closeDate).end,
                ],
            },
            page: page,
        });
    };
    /**
     * 内催待分配预览
     */
    CaseInfoService.prototype.distributePreview = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributePreview,
            data: data,
        });
    };
    /**
     * 内催待分配案件分配
     */
    // distributeCaseInfo(data) {
    //   return this.netService.send({
    //     server: domainService.caseInfoController.distributeCaseInfo,
    //     data: data
    //   })
    // }
    /**
     * 案件跟进记录
     */
    CaseInfoService.prototype.getCaseInfoFollowRecord = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseInfoController.getCaseInfoFollowRecord,
            data: {
                operatorTime: [
                    FilterService.dateRanageFormat(data.operatorTime).start,
                    FilterService.dateRanageFormat(data.operatorTime).end,
                ],
                caseNumber: data.caseNumber,
                type: data.type,
                collectionFeedback: data.collectionFeedback,
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 导出跟进记录(单案件)
     */
    CaseInfoService.prototype.exportFollowRecord = function (caseNumber) {
        return this.netService.send({
            server: domainService.caseInfoController.exportFollowRecord,
            data: {
                caseNumber: caseNumber,
            },
        });
    };
    /**
     */
    CaseInfoService.prototype.innerStrategyDistribute = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.innerStrategyDistribute,
            data: {
                caseIds: data,
            },
        });
    };
    /**
     * 撤销案件(单条)
     */
    CaseInfoService.prototype.revertCaseInfoDistribute = function (batchNumber) {
        return this.netService.send({
            server: domainService.caseInfoController.revertCaseInfoDistribute,
            data: {
                batchNumber: batchNumber,
            },
        });
    };
    /**
     * 撤销案件(多条)
     */
    CaseInfoService.prototype.revertCaseInfoDistributeByCaseId = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.revertCaseInfoDistributeByCaseId,
            data: {
                ids: data,
            },
        });
    };
    /**
     * 提醒已还款案件列表查询(内催已结案)
     */
    CaseInfoService.prototype.getInnerOverCase = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.getInnerOverCase,
            data: {
                'personalInfo.name': data.name,
                'personalInfo.mobileNo': data.mobileNo,
                'personalInfo.idCard': data.idCard,
                principalId: data.principalId,
                batchNumber: data.batchNumber,
                overdueAmount: [data.overdueAmount.min, data.overdueAmount.max],
                payStatus: data.payStatus,
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                delegationDate: [
                    FilterService.dateRanageFormat(data.delegationDate).start,
                    FilterService.dateRanageFormat(data.delegationDate).end,
                ],
                closeDate: [
                    FilterService.dateRanageFormat(data.closeDate).start,
                    FilterService.dateRanageFormat(data.closeDate).end,
                ],
            },
            page: page,
        });
    };
    /**
     * 内催回收案件
     */
    CaseInfoService.prototype.findAllCaseInfoReturn = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.findAllCaseInfoReturn,
            data: {
                'caseId.personalInfo.name': data.name,
                'caseId.personalInfo.mobileNo': data.mobileNo,
                'personalInfo.idCard': data.idCard,
                'caseId.batchNumber': data.batchNumber,
                'caseId.overdueAmount': [
                    data.overdueAmount.min,
                    data.overdueAmount.max,
                ],
                'caseId.payStatus': data.payStatus,
                'caseId.overdueDays': [data.overdueDays.min, data.overdueDays.max],
                operatorTime: [
                    FilterService.dateRanageFormat(data.operatorTime).start,
                    FilterService.dateRanageFormat(data.operatorTime).end,
                ],
            },
            page: page,
        });
    };
    /**
     * 案件再分配
     */
    CaseInfoService.prototype.distributeCeaseInfoAgain = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributeCeaseInfoAgain,
            data: data,
        });
    };
    /**
     * 电催小流转池
     */
    CaseInfoService.prototype.electricSmallCirculation = function (page, data) {
        return this.netService.send({
            server: domainService.caseInfoController.electricSmallCirculation,
            data: {
                companyCode: data.companyCode,
                'personalInfo.name': data.personalName,
                'personalInfo.mobileNo': data.personalPhone,
                orderId: data.orderId,
                overdueAmount: [data.amtRange.min, data.amtRange.max],
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                'personalInfo.idCard': data.idCard,
                batchNumber: data.batchNumber,
                'principalId.id': data.principalId,
                collectionStatus: data.collectionStatus,
                caseType: data.caseType,
            },
            page: page,
        });
    };
    /**
     * 电催强制流转池
     */
    CaseInfoService.prototype.electricForceCirculation = function (page, data) {
        return this.netService.send({
            server: domainService.caseInfoController.electricForceCirculation,
            data: {
                companyCode: data.companyCode,
                'personalInfo.name': data.personalName,
                'personalInfo.mobileNo': data.personalPhone,
                orderId: data.orderId,
                overdueAmount: [data.amtRange.min, data.amtRange.max],
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                'personalInfo.idCard': data.idCard,
                batchNumber: data.batchNumber,
                'principalId.id': data.principalId,
                collectionStatus: data.collectionStatus,
                caseType: data.caseType,
            },
            page: page,
        });
    };
    /**
     * 获取所有批次号
     */
    CaseInfoService.prototype.getAllBatchNumber = function () {
        return this.netService.send({
            server: domainService.caseInfoController.getAllBatchNumber,
        });
    };
    /**
     * 外访小流转池
     */
    CaseInfoService.prototype.outSmallCirculation = function (page, data) {
        return this.netService.send({
            server: domainService.caseInfoController.outSmallCirculation,
            data: {
                companyCode: data.companyCode,
                'personalInfo.name': data.personalName,
                'personalInfo.mobileNo': data.personalPhone,
                orderId: data.orderId,
                overdueAmount: [data.amtRange.min, data.amtRange.max],
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                'personalInfo.idCard': data.idCard,
                collectionStatus: data.collectionStatus,
                caseType: data.caseType,
                principalId: data.principalId,
                'area.id': data.areaId,
            },
            page: page,
        });
    };
    /**
     * 外访强制流转池
     */
    CaseInfoService.prototype.outForceCirculation = function (page, data) {
        return this.netService.send({
            server: domainService.caseInfoController.outForceCirculation,
            data: {
                companyCode: data.companyCode,
                'personalInfo.name': data.personalName,
                'personalInfo.mobileNo': data.personalPhone,
                orderId: data.orderId,
                overdueAmount: [data.amtRange.min, data.amtRange.max],
                overdueDays: [data.overdueDays.min, data.overdueDays.max],
                'personalInfo.idCard': data.idCard,
                collectionStatus: data.collectionStatus,
                caseType: data.caseType,
                principalId: data.principalId,
                'area.id': data.areaId,
            },
            page: page,
        });
    };
    /**
     * 获取案件批注信息
     */
    CaseInfoService.prototype.getCaseInfoRemark = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseInfoController.getCaseInfoRemark,
            data: data,
            page: page,
            sort: sort,
        });
    };
    /**
     * 获取共债案件数量
     * @param data
     * @param page
     */
    CaseInfoService.prototype.getCommonCaseCount = function (id) {
        return this.netService.send({
            server: domainService.caseInfoController.getCommonCaseCount,
            data: {
                caseId: id,
            },
        });
    };
    /**
     * 获取共债案件列表
     * @param data
     * @param page
     */
    CaseInfoService.prototype.queryCaseInfoList = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.queryCaseInfoList,
            data: {
                id: data.id,
                companyCode: data.companyCode,
            },
            page: page,
        });
    };
    /**
     * 分配案件时判断所选用户是否有催收类型
     */
    CaseInfoService.prototype.checkUser = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.checkUser,
            data: {
                userIds: data,
            },
        });
    };
    /**
     * 内催待分配案件评分
     */
    CaseInfoService.prototype.updateInnerWaitCollScore = function () {
        return this.netService.send({
            server: domainService.caseInfoController.updateInnerWaitCollScore,
        });
    };
    /**
     * 案件导入 待分配 手动分配
     */
    CaseInfoService.prototype.distributeCaseInfo = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributeCaseInfo,
            data: data,
        });
    };
    /**
     * 案件导入-待分配案件-手工分配-按条件分配-查询要分配案件个数
     */
    CaseInfoService.prototype.getCaseCount = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.getCaseCount,
            data: data,
        });
    };
    /**
     * 案件导入-待分配案件-手工分配-按条件分配-查询要分配案件总金额
     */
    CaseInfoService.prototype.getOverdueAmount = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.getOverdueAmount,
            data: data,
        });
    };
    /**
     * 案件导入 待分配 手动分配 按条件分配
     */
    CaseInfoService.prototype.distributeCaseInfoByRequest = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributeCaseInfoByRequest,
            data: data,
        });
    };
    /**
     * 案件导入-查询所有待分配案件
     */
    CaseInfoService.prototype.getAllDistributeCaseInfos = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.getAllDistributeCaseInfos,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
            },
            page: page
        });
    };
    /**
     * 案件导入-查询所有已分配案件
     */
    CaseInfoService.prototype.getAllAllocatedCaseInfos = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.getAllAllocatedCaseInfos,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
            },
            page: page
        });
    };
    /**
     * 已分配案件-查询当前案件池类型
     */
    CaseInfoService.prototype.getAllocatedCaseTypeList = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.getAllocatedCaseTypeList,
            data: {
                id: data.id
            }
        });
    };
    /**
     * 已分配案件-重分配案件
     */
    CaseInfoService.prototype.redistributionCaseInfo = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.redistributionCaseInfo,
            data: {
                caseId: data.caseId,
                distributeTypeList: data.distributeTypeList,
                partCollectionDays: data.partCollectionDays,
            }
        });
    };
    /**
     * 已分配案件-批量分案/撤销案件类型
     */
    CaseInfoService.prototype.batchAddDistributeType = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.batchAddDistributeType,
            data: {
                caseIds: data.caseIds,
                distributeTypeList: data.distributeTypeList,
                operateType: data.operateType,
                partCollectionDays: data.partCollectionDays,
            }
        });
    };
    /**
     * 已分配案件-案件导出
     */
    CaseInfoService.prototype.allocatedCaseInfosExport = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.allocatedCaseInfosExport,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                caseIds: data.caseIds
            }
        });
    };
    /**
     * 待分配案件-案件导出
     */
    CaseInfoService.prototype.distributeCaseInfosExport = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributeCaseInfosExport,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                caseIds: data.caseIds
            }
        });
    };
    /**
     * 待分配案件-催记导出
     */
    CaseInfoService.prototype.distributeCaseInfosExportFollow = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.distributeCaseInfosExportFollow,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                caseIds: data.caseIds
            }
        });
    };
    /**
     * 案件管理-查询所有回收案件
     */
    CaseInfoService.prototype.getAllRecoveredCaseInfos = function (data, page) {
        return this.netService.send({
            server: domainService.caseInfoController.getAllRecoveredCaseInfos,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                partDistributeDateMin: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[0]) : '',
                partDistributeDateMax: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[1]) : '',
                returnDateMin: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[0]) : '',
                returnDateMax: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[1]) : '',
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                recoveryType: data.recoveryType,
                debtCollector: data.debtCollector ? data.debtCollector : '',
            },
            page: page
        });
    };
    /**
     * 回收案件-案件导出
     */
    CaseInfoService.prototype.recoveredCaseInfosExport = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.recoveredCaseInfosExport,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                partDistributeDateMin: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[0]) : '',
                partDistributeDateMax: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[1]) : '',
                returnDateMin: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[0]) : '',
                returnDateMax: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[1]) : '',
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                caseIds: data.caseIds,
                recoveryType: data.recoveryType
            }
        });
    };
    /**
     * 回收案件-催记导出
     */
    CaseInfoService.prototype.recoveredCaseInfosExportFollow = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.recoveredCaseInfosExportFollow,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                principalName: data.principalName,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mobileNo: data.mobileNo,
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                personalName: data.personalName,
                carNo: data.carNo,
                idCard: data.idCard,
                overdueAmountStart: data.amountRange ? data.amountRange.min : '',
                overdueAmountEnd: data.amountRange ? data.amountRange.max : '',
                dataFromSource: data.dataFromSource,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                partDistributeDateMin: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[0]) : '',
                partDistributeDateMax: data.partDistributeDate.length ? FilterService.dateTimeFormat(data.partDistributeDate[1]) : '',
                returnDateMin: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[0]) : '',
                returnDateMax: data.returnDate.length ? FilterService.dateTimeFormat(data.returnDate[1]) : '',
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                compensationMoneyMin: data.compensationMoney ? data.compensationMoney.min : '',
                compensationMoneyMax: data.compensationMoney ? data.compensationMoney.max : '',
                caseIds: data.caseIds,
                recoveryType: data.recoveryType
            }
        });
    };
    /**
     * 查询系统参数中部门催收天数
     */
    CaseInfoService.prototype.getCollectionDays = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.getCollectionDays,
            data: {
                distributeType: data,
            },
        });
    };
    /**
     * 更新回收方式
     */
    CaseInfoService.prototype.updateRecoveryType = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.updateRecoveryType,
            data: {
                caseIds: data.caseIds
            }
        });
    };
    CaseInfoService.prototype.queryCaseCollectionRecords = function (data) {
        return this.netService.send({
            server: domainService.caseInfoController.queryCaseCollectionRecords,
            data: {
                caseNumber: data,
            },
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseInfoService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], CaseInfoService.prototype, "caseInfoMarkColor", null);
    return CaseInfoService;
}(Service));
export { CaseInfoService };
